export enum EnumTongHaoStatus {
  Follow = '0',
  Discover = '1',
  InkLightUpLife = '2',
  GoodHomework = '3',
  StudyInsight = '4',
  BackToHoushan = '5',
  SnackTime = '6',
  XuantongGathering = '7',
  ClassmateGathering = '8',
  ClassmateWork = '9',
  FenTong = '10'
}

export enum EnumJoinStatus {
  // 待入群
  Join = '1',
  // 待退出
  Exit = '2'
}

export enum EnumMoreOptions {
  // 更多分桐
  List = '1',
  // 分桐管理
  Manager = '2',
  // 退出分桐
  Exit = '3'
}
